type QueryParams = Record<string, string | number | boolean | undefined | null>;

/**
 * Creates a URL query string from an object of parameters, only including defined values
 * @param params Object containing query parameters
 * @returns Formatted query string including '?' if parameters exist
 */
export const buildQueryString = (params: QueryParams): string => {
    const queryParams = new URLSearchParams();
    
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
        }
    });
    
    const queryString = queryParams.toString();
    return queryString ? `?${queryString}` : '';
}; 